import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import ChartjsPluginStacked100 from 'chartjs-plugin-stacked100'

// The idea is this controller to be another complimentary controller to the charts-js one which
// can have different actions based on clicks
export default class extends Controller {
    static outlets = ['charts-js']

    connect() {}

    changeChartScale(event) {
        if (this.hasChartsJsOutlet && this.chartsJsOutlet.chart) {
            const { type } = event.params
            const { axis } = event.params
            this.chartsJsOutlet.chart.options.scales[axis].type = type
            this.chartsJsOutlet.chart.update()
        } else {
            console.error('Cannot find chart')
        }

        // this.buttonTargets.forEach(button => button.classList.remove("active"))
        ;[...event.currentTarget.parentElement.children].forEach((button) => {
            button.classList.remove('active')
        })
        event.currentTarget.classList.add('active')
    }
}
